import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'excerpt' })
export class ExcerptPipe implements PipeTransform {
	transform(text: string | null | undefined, limit: number = 5): string {
		if (text == null) {
			return '';
		}

		const normalized = String(text);
		const safeLimit = Number.isFinite(limit) && limit > 0 ? Math.floor(limit) : 5;
		if (normalized.length <= safeLimit) {
			return normalized;
		}

		return normalized.substring(0, safeLimit) + '...';
	}
}
